<template>
    <el-menu
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      style="width:200px;"
      router >
      <left_menu :menus="menus"></left_menu>
    </el-menu>
</template>

<script>
    import left_menu from "./menu";
    export default {
      name: "archives_menu",
      data(){
        return {
          menus:[],
        }
      },
      methods: {
        handleOpen(key, keyPath) {
          //console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
          //console.log(key, keyPath);
        },
      },
      components: {
        left_menu
      },
      created(){
        this.menus = this.$store.state.userInfo.menus.oa;
      }
    }
</script>

<style scoped>
  .el-menu{
    border-right:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/left_menu_pure.vue